/**
 * Map a tool key → 3D icon image (mirrors mobile app's `assets/toolbox-icons`).
 * Use the constant rather than inlining paths so the same key can be referenced
 * from the Toolbox tab, Dashboard cards, and tool sub-pages.
 */
export const TOOL_ICONS = {
  'cost-tracker': '/images/toolbox-icons/cost%20tracker.png',
  'milestones': '/images/toolbox-icons/milestones.png',
  'checklists': '/images/toolbox-icons/checklists.png',
  'documents': '/images/toolbox-icons/documents.png',
  'contacts': '/images/toolbox-icons/contacts-hub.png',
  'solar': '/images/toolbox-icons/solar%20Orientation%20guide.png',
  'find-builder': '/images/toolbox-icons/find%20a%20business.png',
  'find-tradie': '/images/toolbox-icons/find-a-tradie.png',
  'find-supplier': '/images/toolbox-icons/find%20a%20business.png',
  'one-on-one': '/images/toolbox-icons/one-to-one-support.png',
  'intelligence': '/images/toolbox-icons/advice.png',
  'facade': '/images/toolbox-icons/facade-visualiser.png',
  'interior-3d': '/images/toolbox-icons/interior-3d.png',
  'quote-compare': '/images/toolbox-icons/voice-record.png',
  'defects': '/images/toolbox-icons/defects%20scanner.png',
  'project-health': '/images/toolbox-icons/project-health-brain.png',
  'advice': '/images/toolbox-icons/advice.png',
  'licence-check': '/images/toolbox-icons/builder%20license%20check.png',
  'insurance-check': '/images/toolbox-icons/building%20insurance%20check.png',
  'gov-resources': '/images/toolbox-icons/government%20resources.png',
  'fhb-discovery': '/images/toolbox-icons/house-and-land.png',
  'furniture-planner': '/images/toolbox-icons/furniture-planner.png',
  'virtual-walkthrough': '/images/toolbox-icons/virtual-walkthrough.png',
  'house-and-land': '/images/toolbox-icons/house-and-land.png',
};

export const toolIcon = (key) => TOOL_ICONS[key] || '/images/toolbox-icons/milestones.png';
